import { render, staticRenderFns } from "./CreateReport.vue?vue&type=template&id=70dae2f8&scoped=true"
import script from "./CreateReport.vue?vue&type=script&lang=js"
export * from "./CreateReport.vue?vue&type=script&lang=js"
import style0 from "./CreateReport.vue?vue&type=style&index=0&id=70dae2f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70dae2f8",
  null
  
)

export default component.exports